import { mealBenefitLimits } from "./country-rules";

const initialMemory = {
  generalParameters: {
    mealDays: 20,
    mealAmount: 0,
    transportAmount: 0,
    nurseryAmount: 0,
  },
  employeeIds: [],
  employeesItems: {},
};

let inMemoryRepo = initialMemory;

function isCustomEmployee({ employeeId, subsidyEmployees }) {
  return subsidyEmployees.reduce(
    (result, subsidyEmployee) =>
      result || subsidyEmployee.employeeId === employeeId,
    false
  );
}

export function getAllowance(property = null) {
  switch (property) {
    case "generalParameters":
      return inMemoryRepo.generalParameters;
    case "employeeIds":
      return inMemoryRepo.employeeIds;
    case "employeesItems":
      return inMemoryRepo.employeesItems;
    default:
      return inMemoryRepo;
  }
}

export function resetAllowanceMemory() {
  inMemoryRepo = initialMemory;
}

export function handlerAllowanceFormatted(type, amount, countryISO2Code) {
  let amountFormatted = amount.toString().replace(",", ".");
  const amountSplitted = amountFormatted.split(".");

  if (amountSplitted[1]) {
    amountFormatted = `${amountSplitted[0]}.${
      !!amountSplitted[1] && amountSplitted[1].slice(0, 2)
    }`;
  }

  const limits = {
    mealAmount: mealBenefitLimits({ country: countryISO2Code }),
    transportAmount: 136.36,
  };
  const limit = limits[type];

  return Math.abs(amountFormatted > limit ? limit : amountFormatted);
}

function calculateSubsidy(
  { subsidyEmployees, employeeId, category, fieldToReturn } = {
    fieldToReturn: "amount",
  }
) {
  const emp = subsidyEmployees.find(
    (employee) => employee.employeeId === employeeId
  );

  // eslint-disable-next-line
  for (const subsidy of emp.subsidies) {
    if (subsidy.category === category) {
      return fieldToReturn === "days"
        ? subsidy.days
        : subsidy.amount.amountInCents / 100;
    }
  }
  return null;
}

export function customEmployeeAllowance({ id, name, value }) {
  inMemoryRepo = {
    ...inMemoryRepo,
    employeesItems: {
      ...inMemoryRepo.employeesItems,
      [id]: {
        ...inMemoryRepo.employeesItems[id],
        [name]: value,
      },
    },
  };
}

export function defaultEmployeeAllowance(id) {
  customEmployeeAllowance({
    id,
    name: "mealDays",
    value: inMemoryRepo.generalParameters.mealDays,
  });
  customEmployeeAllowance({
    id,
    name: "mealAmount",
    value: inMemoryRepo.generalParameters.mealAmount,
  });
  customEmployeeAllowance({
    id,
    name: "transportAmount",
    value: inMemoryRepo.generalParameters.transportAmount,
  });
  customEmployeeAllowance({
    id,
    name: "nurseryAmount",
    value: inMemoryRepo.generalParameters.nurseryAmount,
  });
}

export function changeGeneralParameters({ parameter, value }) {
  inMemoryRepo = {
    ...inMemoryRepo,
    generalParameters: {
      ...inMemoryRepo.generalParameters,
      [parameter]: value,
    },
  };
  inMemoryRepo.employeeIds.map((id) => defaultEmployeeAllowance(id));
}

export function addEmployeeId(id) {
  inMemoryRepo = {
    ...inMemoryRepo,
    employeeIds: [...inMemoryRepo.employeeIds, id],
  };
}

export function loadAllowance(benefitAllowance, employees) {
  benefitAllowance.generalParameters.forEach((generalParameter) => {
    if (generalParameter.category === "meal-benefit") {
      changeGeneralParameters({
        parameter: "mealDays",
        value: generalParameter.days,
      });
      changeGeneralParameters({
        parameter: "mealAmount",
        value: generalParameter.amount.amountInCents / 100,
      });
    } else if (generalParameter.category === "transport-benefit") {
      changeGeneralParameters({
        parameter: "transportAmount",
        value: generalParameter.amount.amountInCents / 100,
      });
    } else if (generalParameter.category === "nursery-benefit") {
      changeGeneralParameters({
        parameter: "nurseryAmount",
        value: generalParameter.amount.amountInCents / 100,
      });
    }
  });

  const subsidyEmployees = benefitAllowance.subsidyEmployees.employees;
  employees.map((e) => {
    if (isCustomEmployee({ employeeId: e.id, subsidyEmployees })) {
      customEmployeeAllowance({
        id: e.id,
        name: "mealDays",
        value: calculateSubsidy({
          subsidyEmployees,
          employeeId: e.id,
          category: "meal-benefit",
          fieldToReturn: "days",
        }),
      });
      customEmployeeAllowance({
        id: e.id,
        name: "mealAmount",
        value: calculateSubsidy({
          subsidyEmployees,
          employeeId: e.id,
          category: "meal-benefit",
        }),
      });
      customEmployeeAllowance({
        id: e.id,
        name: "transportAmount",
        value: calculateSubsidy({
          subsidyEmployees,
          employeeId: e.id,
          category: "transport-benefit",
        }),
      });
      customEmployeeAllowance({
        id: e.id,
        name: "nurseryAmount",
        value: calculateSubsidy({
          subsidyEmployees,
          employeeId: e.id,
          category: "nursery-benefit",
        }),
      });
    } else {
      defaultEmployeeAllowance(e.id);
    }
    return addEmployeeId(e.id);
  });
}
